/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMembership16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={16}
      fill='none'
      viewBox='0 0 17 16'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7 7a3 3 0 100-6 3 3 0 000 6z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M1 15.252s.284-1.93.534-3.518a2.82 2.82 0 012.798-2.38l2.095.01.014-.001h.366c.092 0 .452-.005 1.464-.01'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7.345 14.497a.17.17 0 00.055.138c.038.034.09.05.141.04.525-.091 1.923-.397 1.923-.397l5.495-6.064L13.018 6.5l-5.47 6.04s-.167 1.423-.203 1.957z'
      />
    </svg>
  );
}

export default SvgMembership16;
